import { useEffect } from "react";
import { useMeQuery, useQuoteCreatedSubscription } from "generated/graphql";

type Reexecute = (opts?: { requestPolicy?: "network-only" }) => void;

/**
 * Refetches a quote list the moment the server pushes a quote-created event,
 * so a new lead (vendor side) or quote (customer side) lands on screen without
 * the page being revisited or reloaded.
 *
 * Paused while logged out — an unauthenticated socket is rejected (close 4403)
 * and graphql-ws would keep retrying.
 */
export const useQuoteCreated = (reexecute: Reexecute) => {
  const [{ data: me }] = useMeQuery();
  const [{ data: event }] = useQuoteCreatedSubscription({ pause: !me?.me });

  useEffect(() => {
    if (event?.quoteCreated) {
      reexecute({ requestPolicy: "network-only" });
    }
  }, [event, reexecute]);
};
